import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import { LoadingButton } from "../components/Spinner";
import PasswordInput from "../components/PasswordInput";

export default function ResetPassword() {
  const { token = "" } = useParams();
  const nav = useNavigate();
  const qc = useQueryClient();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);

  const reset = useMutation({
    mutationFn: () => api.resetPassword(token, password),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["me"] });
      nav("/");
    },
    onError: (e) => setErr(parseErr(e)),
  });

  return (
    <div className="grid h-full place-items-center bg-bg p-6">
      <div className="card auth-card max-w-md w-full p-8 space-y-5">
        <h1 className="text-xl font-semibold text-center">Choose a new password</h1>
        <form
          className="space-y-3"
          onSubmit={(e) => { e.preventDefault(); setErr(null); reset.mutate(); }}
        >
          <PasswordInput
            required
            minLength={8}
            placeholder="New password (8+ chars)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            autoFocus
          />
          {err && <p className="text-xs text-danger">{err}</p>}
          <LoadingButton
            type="submit"
            className="btn-primary w-full justify-center"
            pending={reset.isPending}
            pendingLabel="Resetting…"
          >
            Reset password
          </LoadingButton>
        </form>
      </div>
    </div>
  );
}

function parseErr(e: unknown): string {
  const m = String((e as Error).message ?? "");
  if (m.includes("invalid_token")) return "This reset link is invalid or has expired.";
  if (m.includes("bad_input")) return "Password must be at least 8 characters.";
  return "Couldn't reset your password.";
}
